import React from 'react';
import { Button, Spinner } from 'flowbite-react'; // Import Button and Spinner from Flowbite-React
import { HiExclamationCircle } from 'react-icons/hi'; // Import icon

// This is a reusable component for displaying a confirmation dialog.
const ConfirmationModal = ({ show, onClose, onConfirm, message, confirmText, cancelText, loading }) => {
    if (!show) {
        return null;
    }

    return (
        // Overlay
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50">
            {/* Modal Dialog */}
            <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                    {/* Header - Close Button */}
                    <button
                        type="button"
                        className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                        onClick={onClose}
                    >
                        <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
                        </svg>
                        <span className="sr-only">Close modal</span>
                    </button>

                    {/* Body */}
                    <div className="p-6 text-center">
                        <HiExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            {message}
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button
                                color="failure"
                                onClick={onConfirm}
                                disabled={loading}
                                className="inline-flex items-center"
                            >
                                {loading ? <Spinner size="sm" className="mr-2" /> : ''}
                                {confirmText}
                            </Button>
                            <Button
                                color="gray"
                                onClick={onClose}
                                disabled={loading}
                            >
                                {cancelText}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
